import { Container, Grid, Paper, Text, Title, Group, ThemeIcon, Skeleton } from "@mantine/core";
import Topnavbar from "../../Layouts/Topnavbar";
import { IconApi, IconGraph, IconUser, IconWallet } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { Userauthcontexthooks } from "../../Hooks/Userauthcontexthooks";
import { Get_Admin_Dashboard_Details } from "../../apicall";
import { message } from "antd";








const Admindashboard = ({ Headername }) => {
    const { user } = Userauthcontexthooks();
    const [dashboardDetails, setDashboardDetails] = useState(null);
    const [dahboardloading, setdashboardloading] = useState(true);

    useEffect(() => {
        const fetchDashboardDetails = async () => {
            try {
                const data = await Get_Admin_Dashboard_Details();

                if (data.success) {
                    //console.log(data);
                    setDashboardDetails(data?.dashboard)
                }

            } catch (error) {

                message.error(
                    error.response?.data?.message ||
                    "Something went wrong."
                );
            } finally {
                setdashboardloading(false);
            }
        }

        if (user) {
            fetchDashboardDetails();
        }
    }, [user])
    return (
        <>
            <Topnavbar Headername={Headername} />
            <Container size={'xl'} mt={'sm'}>
                <Title c={'dimmed'}>Dashboard</Title>
                <Text size="xs">You can view your business performance.</Text>
            </Container>

            <Container size="lg" mt="lg">
                <Title order={3} c={'blue'} mb={'xs'}>Summary:</Title>
                <Grid>
                    <Grid.Col span={{ xs: 12, sm: 6, md: 3, }}>
                        <Skeleton visible={dahboardloading} height={150}>
                            <Paper radius="xs"
                                p="lg"
                                shadow="sm"
                                withBorder
                                style={{
                                    cursor: "pointer",
                                    transition: "all .25s ease",
                                    height: 150,
                                }}>
                                <Group justify="space-between">
                                    <ThemeIcon
                                        radius="xl"
                                        size={54}
                                        color={'green'}
                                        variant="light"
                                    >
                                        <IconWallet size={28} />
                                    </ThemeIcon>


                                </Group>

                                <Text fw={700} mt="lg" size="lg">
                                    ₹{dashboardDetails?.summary?.retailerBalance || 0}
                                </Text>

                                <Text c="dimmed" size="xs" mt={2}>
                                    Retailer Balance
                                </Text>
                            </Paper>
                        </Skeleton>
                    </Grid.Col>
                    <Grid.Col span={{ xs: 12, sm: 6, md: 3, }}>
                        <Skeleton visible={dahboardloading} height={150}>
                            <Paper radius="xs"
                                p="lg"
                                shadow="sm"
                                withBorder
                                style={{
                                    cursor: "pointer",
                                    transition: "all .25s ease",
                                    height: 150,
                                }}>
                                <Group justify="space-between">
                                    <ThemeIcon
                                        radius="xl"
                                        size={54}
                                        color={'green'}
                                        variant="light"
                                    >
                                        <IconWallet size={28} />
                                    </ThemeIcon>


                                </Group>

                                <Text fw={700} mt="lg" size="lg">
                                    ₹{dashboardDetails?.summary?.distributorBalance || 0}
                                </Text>

                                <Text c="dimmed" size="xs" mt={2}>
                                    Distributor Balance
                                </Text>
                            </Paper>
                        </Skeleton>
                    </Grid.Col>
                    <Grid.Col span={{ xs: 12, sm: 6, md: 3, }}>
                        <Skeleton visible={dahboardloading} height={150}>
                            <Paper radius="xs"
                                p="lg"
                                shadow="sm"
                                withBorder
                                style={{
                                    cursor: "pointer",
                                    transition: "all .25s ease",
                                    height: 150,
                                }}>
                                <Group justify="space-between">
                                    <ThemeIcon
                                        radius="xl"
                                        size={54}
                                        color={'green'}
                                        variant="light"
                                    >
                                        <IconWallet size={28} />
                                    </ThemeIcon>


                                </Group>

                                <Text fw={700} mt="lg" size="lg">
                                    ₹{dashboardDetails?.summary?.masterDistributorBalance || 0}
                                </Text>

                                <Text c="dimmed" size="xs" mt={2}>
                                    MD Distributor Balance
                                </Text>
                            </Paper>
                        </Skeleton>
                    </Grid.Col>
                    <Grid.Col span={{ xs: 12, sm: 6, md: 3, }}>
                        <Skeleton visible={dahboardloading} height={150}>
                            <Paper radius="xs"
                                p="lg"
                                shadow="sm"
                                withBorder
                                style={{
                                    cursor: "pointer",
                                    transition: "all .25s ease",
                                    height: 150,
                                }}>
                                <Group justify="space-between">
                                    <ThemeIcon
                                        radius="xl"
                                        size={54}
                                        color={'red'}
                                        variant="light"
                                    >
                                        <IconWallet size={28} />
                                    </ThemeIcon>

                                </Group>

                                <Text fw={700} mt="lg" size="lg">
                                    ₹{dashboardDetails?.summary?.retailerCredit || 0}
                                </Text>

                                <Text c="dimmed" size="xs" mt={2}>
                                    Retailer Credit
                                </Text>
                            </Paper>
                        </Skeleton>
                    </Grid.Col>
                    <Grid.Col span={{ xs: 12, sm: 6, md: 3, }}>
                        <Skeleton visible={dahboardloading} height={150}>
                            <Paper radius="xs"
                                p="lg"
                                shadow="sm"
                                withBorder
                                style={{
                                    cursor: "pointer",
                                    transition: "all .25s ease",
                                    height: 150,
                                }}>
                                <Group justify="space-between">
                                    <ThemeIcon
                                        radius="xl"
                                        size={54}
                                        color={'red'}
                                        variant="light"
                                    >
                                        <IconWallet size={28} />
                                    </ThemeIcon>

                                </Group>

                                <Text fw={700} mt="lg" size="lg">
                                    ₹{dashboardDetails?.summary?.distributorCredit || 0}
                                </Text>

                                <Text c="dimmed" size="xs" mt={2}>
                                    Distributor Credit
                                </Text>
                            </Paper>
                        </Skeleton>
                    </Grid.Col>
                    <Grid.Col span={{ xs: 12, sm: 6, md: 3, }}>
                        <Skeleton visible={dahboardloading} height={150}>
                            <Paper radius="xs"
                                p="lg"
                                shadow="sm"
                                withBorder
                                style={{
                                    cursor: "pointer",
                                    transition: "all .25s ease",
                                    height: 150,
                                }}>
                                <Group justify="space-between">
                                    <ThemeIcon
                                        radius="xl"
                                        size={54}
                                        color={'red'}
                                        variant="light"
                                    >
                                        <IconWallet size={28} />
                                    </ThemeIcon>


                                </Group>

                                <Text fw={700} mt="lg" size="lg">
                                    ₹{dashboardDetails?.summary?.masterDistributorCredit || 0}
                                </Text>

                                <Text c="dimmed" size="xs" mt={2}>
                                    MD Distributor Credit
                                </Text>
                            </Paper>
                        </Skeleton>
                    </Grid.Col>

                </Grid>
            </Container>

            <Container size="lg" mt="lg">
                <Title order={3} c={'blue'} mb={'xs'}>Users:</Title>
                <Grid>
                    <Grid.Col span={{ xs: 12, sm: 6, md: 3, }}>
                        <Skeleton visible={dahboardloading} height={150}>
                            <Paper radius="xs"
                                p="lg"
                                shadow="sm"
                                withBorder
                                style={{
                                    cursor: "pointer",
                                    transition: "all .25s ease",
                                    height: 150,
                                }}>
                                <Group justify="space-between">
                                    <ThemeIcon
                                        radius="xl"
                                        size={54}
                                        color={'violet'}
                                        variant="light"
                                    >
                                        <IconUser size={28} />
                                    </ThemeIcon>


                                </Group>

                                <Text fw={700} mt="lg" size="lg">
                                    {dashboardDetails?.users?.totalMD || 0}
                                </Text>

                                <Text c="dimmed" size="xs" mt={2}>
                                    Total MD Distributors
                                </Text>
                            </Paper>
                        </Skeleton>
                    </Grid.Col>
                    <Grid.Col span={{ xs: 12, sm: 6, md: 3, }}>
                        <Skeleton visible={dahboardloading} height={150}>
                            <Paper radius="xs"
                                p="lg"
                                shadow="sm"
                                withBorder
                                style={{
                                    cursor: "pointer",
                                    transition: "all .25s ease",
                                    height: 150,
                                }}>
                                <Group justify="space-between">
                                    <ThemeIcon
                                        radius="xl"
                                        size={54}
                                        color={'violet'}
                                        variant="light"
                                    >
                                        <IconUser size={28} />
                                    </ThemeIcon>


                                </Group>

                                <Text fw={700} mt="lg" size="lg">
                                    {dashboardDetails?.users?.totalDistributor || 0}
                                </Text>

                                <Text c="dimmed" size="xs" mt={2}>
                                    Total Distributors
                                </Text>
                            </Paper>
                        </Skeleton>
                    </Grid.Col>
                    <Grid.Col span={{ xs: 12, sm: 6, md: 3, }}>
                        <Skeleton visible={dahboardloading} height={150}>
                            <Paper radius="xs"
                                p="lg"
                                shadow="sm"
                                withBorder
                                style={{
                                    cursor: "pointer",
                                    transition: "all .25s ease",
                                    height: 150,
                                }}>
                                <Group justify="space-between">
                                    <ThemeIcon
                                        radius="xl"
                                        size={54}
                                        color={'violet'}
                                        variant="light"
                                    >
                                        <IconUser size={28} />
                                    </ThemeIcon>


                                </Group>

                                <Text fw={700} mt="lg" size="lg">
                                    {dashboardDetails?.users?.totalRetailer || 0}
                                </Text>

                                <Text c="dimmed" size="xs" mt={2}>
                                    Total Retailers
                                </Text>
                            </Paper>
                        </Skeleton>
                    </Grid.Col>
                    <Grid.Col span={{ xs: 12, sm: 6, md: 3, }}>
                        <Skeleton visible={dahboardloading} height={150}>
                            <Paper radius="xs"
                                p="lg"
                                shadow="sm"
                                withBorder
                                style={{
                                    cursor: "pointer",
                                    transition: "all .25s ease",
                                    height: 150,
                                }}>
                                <Group justify="space-between">
                                    <ThemeIcon
                                        radius="xl"
                                        size={54}
                                        color={'violet'}
                                        variant="light"
                                    >
                                        <IconUser size={28} />
                                    </ThemeIcon>


                                </Group>

                                <Text fw={700} mt="lg" size="lg">
                                    {dashboardDetails?.users?.activeMD || 0}
                                </Text>

                                <Text c="dimmed" size="xs" mt={2}>
                                    Active MD Distributors
                                </Text>
                            </Paper>
                        </Skeleton>
                    </Grid.Col>
                    <Grid.Col span={{ xs: 12, sm: 6, md: 3, }}>
                        <Skeleton visible={dahboardloading} height={150}>
                            <Paper radius="xs"
                                p="lg"
                                shadow="sm"
                                withBorder
                                style={{
                                    cursor: "pointer",
                                    transition: "all .25s ease",
                                    height: 150,
                                }}>
                                <Group justify="space-between">
                                    <ThemeIcon
                                        radius="xl"
                                        size={54}
                                        color={'violet'}
                                        variant="light"
                                    >
                                        <IconUser size={28} />
                                    </ThemeIcon>


                                </Group>

                                <Text fw={700} mt="lg" size="lg">
                                    {dashboardDetails?.users?.activeDistributor || 0}
                                </Text>

                                <Text c="dimmed" size="xs" mt={2}>
                                    Active Distributors
                                </Text>
                            </Paper>
                        </Skeleton>
                    </Grid.Col>
                    <Grid.Col span={{ xs: 12, sm: 6, md: 3, }}>
                        <Skeleton visible={dahboardloading} height={150}>
                            <Paper radius="xs"
                                p="lg"
                                shadow="sm"
                                withBorder
                                style={{
                                    cursor: "pointer",
                                    transition: "all .25s ease",
                                    height: 150,
                                }}>
                                <Group justify="space-between">
                                    <ThemeIcon
                                        radius="xl"
                                        size={54}
                                        color={'violet'}
                                        variant="light"
                                    >
                                        <IconUser size={28} />
                                    </ThemeIcon>


                                </Group>

                                <Text fw={700} mt="lg" size="lg">
                                    {dashboardDetails?.users?.activeRetailer || 0}
                                </Text>

                                <Text c="dimmed" size="xs" mt={2}>
                                    Active Retailers
                                </Text>
                            </Paper>
                        </Skeleton>
                    </Grid.Col>
                </Grid>
            </Container>

            <Container size="lg" mt="lg">
                <Title order={3} c={'blue'} mb={'xs'}>Turnover:</Title>
                <Grid>
                    <Grid.Col span={{ xs: 12, sm: 6, md: 4, }}>
                        <Skeleton visible={dahboardloading} height={150}>
                            <Paper radius="xs"
                                p="lg"
                                shadow="sm"
                                withBorder
                                style={{
                                    cursor: "pointer",
                                    transition: "all .25s ease",
                                    height: 150,
                                }}>
                                <Group justify="space-between">
                                    <ThemeIcon
                                        radius="xl"
                                        size={54}
                                        color={'lime'}
                                        variant="light"
                                    >
                                        <IconGraph size={28} />
                                    </ThemeIcon>


                                </Group>

                                <Text fw={700} mt="lg" size="lg">
                                    ₹{dashboardDetails?.turnover?.today || 0}
                                </Text>

                                <Text c="dimmed" size="xs" mt={2}>
                                    Today Turnover
                                </Text>
                            </Paper>
                        </Skeleton>
                    </Grid.Col>
                    <Grid.Col span={{ xs: 12, sm: 6, md: 4, }}>
                        <Skeleton visible={dahboardloading} height={150}>
                            <Paper radius="xs"
                                p="lg"
                                shadow="sm"
                                withBorder
                                style={{
                                    cursor: "pointer",
                                    transition: "all .25s ease",
                                    height: 150,
                                }}>
                                <Group justify="space-between">
                                    <ThemeIcon
                                        radius="xl"
                                        size={54}
                                        color={'lime'}
                                        variant="light"
                                    >
                                        <IconGraph size={28} />
                                    </ThemeIcon>


                                </Group>

                                <Text fw={700} mt="lg" size="lg">
                                    ₹{dashboardDetails?.turnover?.weekly || 0}
                                </Text>

                                <Text c="dimmed" size="xs" mt={2}>
                                    Weekly Turnover
                                </Text>
                            </Paper>
                        </Skeleton>
                    </Grid.Col>
                    <Grid.Col span={{ xs: 12, sm: 6, md: 4, }}>
                        <Skeleton visible={dahboardloading} height={150}>
                            <Paper radius="xs"
                                p="lg"
                                shadow="sm"
                                withBorder
                                style={{
                                    cursor: "pointer",
                                    transition: "all .25s ease",
                                    height: 150,
                                }}>
                                <Group justify="space-between">
                                    <ThemeIcon
                                        radius="xl"
                                        size={54}
                                        color={'lime'}
                                        variant="light"
                                    >
                                        <IconGraph size={28} />
                                    </ThemeIcon>


                                </Group>

                                <Text fw={700} mt="lg" size="lg">
                                    ₹{dashboardDetails?.turnover?.monthly || 0}
                                </Text>

                                <Text c="dimmed" size="xs" mt={2}>
                                    Monthly Turnover
                                </Text>
                            </Paper>
                        </Skeleton>
                    </Grid.Col>
                    <Grid.Col span={{ xs: 12, sm: 6, md: 4, }}>
                        <Skeleton visible={dahboardloading} height={150}>
                            <Paper radius="xs"
                                p="lg"
                                shadow="sm"
                                withBorder
                                style={{
                                    cursor: "pointer",
                                    transition: "all .25s ease",
                                    height: 150,
                                }}>
                                <Group justify="space-between">
                                    <ThemeIcon
                                        radius="xl"
                                        size={54}
                                        color={'lime'}
                                        variant="light"
                                    >
                                        <IconGraph size={28} />
                                    </ThemeIcon>


                                </Group>

                                <Text fw={700} mt="lg" size="lg">
                                    ₹{dashboardDetails?.turnover?.yearly || 0}
                                </Text>

                                <Text c="dimmed" size="xs" mt={2}>
                                    Yearly Turnover
                                </Text>
                            </Paper>
                        </Skeleton>
                    </Grid.Col>
                </Grid>
            </Container>

            <Container size="lg" mt="lg" mb={'sm'}>
                <Title order={3} c={'blue'} mb={'xs'}>API Balance:</Title>
                <Grid>
                    <Grid.Col span={{ xs: 12, sm: 6, md: 4, }}>
                        <Paper radius="xs"
                            p="lg"
                            shadow="sm"
                            withBorder
                            style={{
                                cursor: "pointer",
                                transition: "all .25s ease",
                                height: 150,
                            }}>
                            <Group justify="space-between">
                                <ThemeIcon
                                    radius="xl"
                                    size={54}
                                    color={'teal'}
                                    variant="light"
                                >
                                    <IconApi size={28} />
                                </ThemeIcon>

                            </Group>

                            <Text fw={700} mt="lg" size="lg">
                                ₹0,000
                            </Text>

                            <Text c="dimmed" size="xs" mt={2}>
                                BOOM PAY API BALANCE
                            </Text>
                        </Paper>
                    </Grid.Col>
                </Grid>
            </Container>
        </>
    )
}
export default Admindashboard;